import { ViolationStatus } from '../../../api/rentalscape/__generated_types__/graphql';

/**
 * Defines the allowed transitions for each violation status based on business rules
 *
 * Source of truth - https://github.com/deckardtech/deckard-rest/blob/2f3b09d824e20be59055cc015ed92a87c7c05323/deckard-rest-datamesh/src/deckard_rest_datamesh/resolvers/mutation/violation_transitions.py#L83
 * Ensure this file is kept in sync with the source of truth
 */
export const ALLOWED_STATUS_TRANSITIONS: Record<
  ViolationStatus,
  ViolationStatus[]
> = {
  [ViolationStatus.Active]: [
    ViolationStatus.UnderReview,
    ViolationStatus.Suspended,
    ViolationStatus.Ignored,
  ],
  [ViolationStatus.UnderReview]: [
    ViolationStatus.Active,
    ViolationStatus.Suspended,
    ViolationStatus.Ignored,
  ],
  [ViolationStatus.Suspended]: [
    ViolationStatus.Active,
    ViolationStatus.UnderReview,
    ViolationStatus.Ignored,
  ],
  [ViolationStatus.Closed]: [], // No transitions allowed from CLOSED
  [ViolationStatus.Ignored]: [
    ViolationStatus.Active,
    ViolationStatus.Suspended,
    ViolationStatus.UnderReview,
  ],
  [ViolationStatus.Unknown]: [],
};

/**
 * Determines if a transition from one status to another is allowed
 */
export function isValidStatusTransition(
  currentStatus: ViolationStatus,
  targetStatus: ViolationStatus
): boolean {
  // If statuses are the same, not a transition
  if (currentStatus === targetStatus) {
    return true;
  }

  return ALLOWED_STATUS_TRANSITIONS[currentStatus].includes(targetStatus);
}

/**
 * Gets all allowed status transitions from the current status
 */
export function getAllowedStatusTransitions(
  currentStatus: ViolationStatus
): ViolationStatus[] {
  return [currentStatus, ...ALLOWED_STATUS_TRANSITIONS[currentStatus]];
}
